import { CanActivate } from '@angular/router'
import { Injectable } from '@angular/core'
import { RoutingService } from '@spartacus/core'
import { map } from 'rxjs/operators'
import { MbConstants } from '../../shared/mb-constants'

@Injectable({
  providedIn: 'root'
})
export class MbPoUploadConfirmationPageGuard implements CanActivate {

  constructor (protected routingService: RoutingService) { }

  canActivate () {
    return this.routingService.getPageContext().pipe(
      map(pageContext => {
        if (pageContext?.id?.includes(MbConstants.PO_UPLOAD_URL)) {
          return true
        } else {
          this.routingService.go('/')
          return false
        }
      })
    )
  }
}
